
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";

type PairRowStyle = Record<
  "--pair-item-ratio" | "--pair-row-ratio-sum",
  number
>;
type OssMap = Record<string, string>;

export default Vue.extend({
  data() {
    return {
      row02Image: "am_relic_80_new_02_mobile_en",
      row03Images: ["am_relic_80_new_03_01", "am_relic_80_new_03_02"],
      pairRowRatios: {
        row03: [1280 / 854, 1280 / 854],
        row04: [854 / 1280, 1280 / 854],
        row07: [1280 / 853, 1280 / 853],
        row09: [854 / 1280, 1280 / 853],
        row23: [1280 / 853, 1280 / 717]
      },
      row04Images: ["am_relic_80_new_04_01", "am_relic_80_new_04_02"],
      row05Image: "am_relic_80_new_05_mobile_en",
      row06Image: "am_relic_80_new_06_mobile_en",
      row07Images: ["am_relic_80_new_07_01", "am_relic_80_new_07_02"],
      row08Image: "am_relic_80_new_08_mobile_en",
      row09Images: ["am_relic_80_new_09_01", "am_relic_80_new_09_02"],
      row10Image: "am_relic_80_new_10_mobile_en",
      row11Images: [
        "am_relic_80_new_11_01",
        "am_relic_80_new_11_02",
        "am_relic_80_new_11_03",
        "am_relic_80_new_11_04"
      ],
      row12Images: [
        "am_relic_80_new_12_01",
        "am_relic_80_new_12_02",
        "am_relic_80_new_12_03",
        "am_relic_80_new_12_04"
      ],

      row13Image: "am_relic_80_new_13_mobile_en",
      row14Image: "am_relic_80_new_14_mobile_en",
      row15Image: "am_relic_80_new_15_mobile_en",
      structureItems: [
        {
          image: "am_relic_80_new_16_01",
          textKey: "AMRelic80NEW.imageText01"
        },
        {
          image: "am_relic_80_new_16_02",
          textKey: "AMRelic80NEW.imageText02"
        },
        {
          image: "am_relic_80_new_17_01",
          textKey: "AMRelic80NEW.imageText03"
        },
        {
          image: "am_relic_80_new_17_02",
          textKey: "AMRelic80NEW.imageText04"
        },
        {
          image: "am_relic_80_new_18_01",
          textKey: "AMRelic80NEW.imageText05"
        },
        {
          image: "am_relic_80_new_18_02",
          textKey: "AMRelic80NEW.imageText06"
        },
        {
          image: "am_relic_80_new_19_01",
          textKey: "AMRelic80NEW.imageText07"
        },
        {
          image: "am_relic_80_new_19_02",
          textKey: "AMRelic80NEW.imageText08"
        }
      ],
      row20Image: "am_relic_80_new_20_01",
      row21Image: "am_relic_80_new_21_01",
      row22Image: "am_relic_80_new_22_02",
      row23Images: ["am_relic_80_new_23_01", "am_relic_80_new_23_02"]
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      url: "url",
      oss: "oss"
    }),
    row01Image() {
      if (this.isMobile) {
        return this.isCN
          ? "am_relic_80_new_01_mobile_cn"
          : "am_relic_80_new_01_mobile_en";
      }
      return this.isCN ? "am_relic_80_new_01_cn" : "am_relic_80_new_01_en";
    },
    row12_2Image() {
      return this.isCN ? "am_relic_80_new_12_2_cn" : "am_relic_80_new_12_2_en";
    }
  },
  methods: {
    resolvePairItemStyle(
      ratios: number[],
      index: number
    ): PairRowStyle | undefined {
      if (this.isMobile) {
        return undefined;
      }
      const ratioSum = ratios.reduce((sum, ratio) => sum + ratio, 0);
      return {
        "--pair-item-ratio": ratios[index],
        "--pair-row-ratio-sum": ratioSum
      };
    },
    resolveOssImage(key: string): string {
      return (this.oss as OssMap)[key];
    },
    resolveOssImages(keys: string[]): string[] {
      return keys.map(key => (this.oss as OssMap)[key]);
    },
    onDownload() {
      download(this.oss.pdf_am_relic_80);
    },
    onVerify() {
      window.open(this.$paths.verify + "cyberboard/", "_blank");
    }
  }
});
